import Swal from "sweetalert2";
import axios from "axios";

const DeleteRole = async (roleId, refreshList) => {
  Swal.fire({
    title: "Delete this Role?",
    text: "This role will be permanently deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#c51369",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, Delete",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const res = await axios.delete(
          `${process.env.REACT_APP_API_URL}/role-permission/delete-role/${roleId}`
        );

        if (res.data.success) {
          Swal.fire({
            title: "Deleted!",
            text: "Role removed successfully.",
            icon: "success",
            timer: 1400,
            showConfirmButton: false,
          });
          refreshList();
        }
      } catch (error) {
        Swal.fire({
          title: "Oops!",
          text: error.response?.data?.message || "Something went wrong.",
          icon: "error",
        });
      }
    }
  });
};

export default DeleteRole;
